import React from "react";
//--
export default class ReportExport extends React.Component {
    render() {
        let { link } = this.props;
        return (React.createElement("a", { target: "_blank", href: link }, "Export"));
    }
}
